var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-indication",on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$getLocaleString('BUTTON_DYSPORT_INDICATION'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }